const $ = require('jquery');

const tabElement = {

	init() {
		this.$el = $('.js-lottie-tabs');
		if (this.$el.length > 0) {
			this.setup();
		}
	},
	setup() {
		this.tabsElementSetup();
		
	},
	tabsElementSetup() {
		//Start -- Simple tabs for Opportunity LP
		var id_array = [];
		var title_array = [];
		var tab_id = '';
		var tab_text = '';
		var data_tab = '';
		var mobile_tab = '';
		
		$('.c-simple-tabs__nav .tabs .tab a').each(function () {
			tab_text = $(this).text();
			data_tab = $(this).attr('data-tab');
			
			id_array.push(data_tab);
			title_array.push(tab_text);
			
			//Desktop tab click event
			$(this).on('click', function (e) {
				//Tabs
				tab_id = $(this).attr('data-tab');
				
				//tab Content Hide
				$('.tabs li a').removeClass('js-active');
				$('.c-simple-tabs__main').find('.c-simple-tabs__content').removeClass('js-active');

				//tab Content Show
				$(this).addClass('js-active');
				$('#' + tab_id).addClass('js-active');

				tabElement.lottieFire(tab_id);
				
				e.preventDefault();
	
			});

		});

		$('.c-simple-tabs__main .c-simple-tabs__content').each(function (index) {
			
			//Create mobile tab
			$(this).find('.c-simple-tabs__text').prepend('<a href="#" class="mobile-tab" data-tab="'+ id_array[index] +'">' + title_array[index] + '</a>');

			//Mobile tab click event
			$(this).on('click', function (e) {
				mobile_tab = $(this).find('.mobile-tab').attr('data-tab');
				
				//tab Content Hide
				$('.c-simple-tabs .c-simple-tabs__nav .tabs').find('a').removeClass('js-active');
				$('.c-simple-tabs__main').find('.c-simple-tabs__content').removeClass('js-active');

				//tab Content Hide
				$(this).find('.wpb_wrapper').addClass('active-mobile');
				$(this).closest('.c-simple-tabs__content').addClass('js-active');
				$('.c-simple-tabs .c-simple-tabs__nav .tabs').find('a[data-tab="' + mobile_tab + '"]').addClass('js-active');

				tabElement.lottieFire(mobile_tab);

				e.preventDefault();
			});
		});

		//END -- Simple tabs for Opportunity LP
	},
	lottieFire(x) {
		//Reset lottie animations when tab is clicked
		$('#' + x).find('lottie-player').get(0).stop();
		$('#' + x).find('lottie-player').get(0).play();
	}
};

$(tabElement.init.bind(tabElement));
